import React, { useState, useEffect } from "react";
import {
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  toast,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBIcon,
} from "mdbreact";
/* import { MDBContainer, MDBRow, MDBCol, MDBInput, MDBBtn, MDBIcon
  ,MDBModal,MDBModalBody , MDBModalHeader, MDBModalFooter } from 'mdbreact'; */

import Axios from "axios";

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

import WarningBox from "../components/WarningBox";
import InfoBox from "../components/InfoBox";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { intlFormat, set } from "date-fns";
import AdminAccess from "../Administrator/AdminAccess";

const ViewSales = (props) => {
  const useMountEffect = (functionName) => useEffect(functionName, []);
  const serverURL = props.apiServer;
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const [intLength, setLength] = useState(0);
  const [isUpdated, setUpdate] = useState(false);

  const [frm, setValues] = useState({
    code: props.code,
    barcode: "",

    parentcode: props.parentcode,
    quantity: 1,
    price: 0,
    dateencoded: new Date(),
    usercode: sessionStorage.getItem("msal.uc"),
    returned: props.returned,
    totalprice: "",
    itemcode: "",
    item: "",
    sellingprice: 0,
    amounttendered: 0,
    discountamount: 0,
    discountrate: props.discountrate,
    discount: props.discounttype,
    discountcode: props.discountcode,
  });

  const [barcodeInputValue, updateBarcodeInputValue] = useState("");
  const [unitofmeasure, setUnitOfMeasure] = useState("");
  const [disabled, setDisabled] = useState("");

  const updateField = (e) => {
    const target = e.target;

    let value = target.value;
    let name = target.id;

    if (target.type === "checkbox") {
      value = target.checked;
      setValues({ ...frm, [name]: value });
    } else {
      setValues({ ...frm, [name]: value });
      // setUpdate(!isUpdated);
      if (name === "quantity") {
        getTotalPrice(value);
      }
      if (name === "barcode") {
        console.log(intLength + " / " + value.length);

        if (intLength === value.length) {
          getSearchResult(value);
        }
        setLength(value.length);
      }
    }
  };

  function barcodeAutoFocus() {
    document.getElementById("barcode").focus();
  }

  function onChangeBarcode(event) {
    updateBarcodeInputValue(event.target.value);
    getSearchResult(event.target.value);
  }

  function onKeyPressBarcode(event) {
    if (event.keyCode === 13) {
      updateBarcodeInputValue(event.target.value);
      getSearchResult(event.target.value);
    }
  }

  const getSearchResult = (x) => {
    //  console.log(x);

    Axios.get(serverURL + "/searchitemdetails?acode=" + x, bearer)
      .then((res) => {
        if (res.data !== "empty") {
          if (res.data === "norecord") {
            setValues({
              ...frm,
              barcode: barcodeInputValue,
              itemcode: "No record found",
              item: "No record found",
              sellingprice: 0,
              totalprice: 0,
            });
          } else {
            let tmpSellingPrice =
              frm.discountcode === "SC"
                ? (res.data.sellingprice / 1.12).toFixed(2)
                : res.data.sellingprice.toFixed(2);
            let tmpDiscountAmount =
              frm.discountcode === "SC"
                ? (tmpSellingPrice * frm.quantity * frm.discountrate).toFixed(2)
                : (
                    res.data.sellingprice *
                    frm.quantity *
                    frm.discountrate
                  ).toFixed(2);
            let tmpTotalPrice =
              frm.discountcode === "SC"
                ? (
                    tmpSellingPrice *
                    frm.quantity *
                    (1 - frm.discountrate)
                  ).toFixed(2)
                : (
                    res.data.sellingprice *
                    frm.quantity *
                    (1 - frm.discountrate)
                  ).toFixed(2);

            setValues({
              ...frm,

              barcode: barcodeInputValue,
              itemcode: res.data.code,
              item: res.data.description,
              sellingprice: tmpSellingPrice,
              totalprice: tmpTotalPrice,
              discountamount: tmpDiscountAmount,
            });
          }
        } else {
          //  ClearFields();
        }
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const searchItem = (e) => {
    const target = e.target;

    let value = target.value;
    let name = target.id;

    if (target.type === "checkbox") {
      return;
    } else {
      setValues({ ...frm, [name]: value });
      // console.log(value);

      getSearchResult(value);
    }
  };

  const getTotalPrice = (x) => {
    // console.log(x);
    setValues({
      ...frm,

      quantity: x,
      totalprice: frm.sellingprice * x * (1 - props.discountrate),
    });
  };

  const handleChange = (objName) => (selOption) => {
    setValues({ ...frm, [objName]: selOption });
  };

  const getDateValue = (dtPickerName) => (actualValue) => {
    setValues({ ...frm, [dtPickerName]: actualValue });
  };

  function submitHandler(event) {
    event.preventDefault();
    event.target.className += " was-validated";

    savesales();
  }

  const [errorMessage, setErrorMessage] = useState("");

  const [modalWarning, showWarningBox] = useState(false);

  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  };

  const [modalInfo, showInfoBox] = useState(false);

  const toggleInfoBox = () => {
    showInfoBox(!modalInfo);
  };

  const ClearFields = () => {
    setValues({
      ...frm,
      code: props.code,
      barcode: "",

      parentcode: props.parentcode,
      // ,quantity:1
      price: 0,
      dateencoded: new Date(),
      usercode: sessionStorage.getItem("msal.uc"),
      returned: props.returned,
      totalprice: "",
      itemcode: "",
      item: "",
      sellingprice: 0,
      discountamount: 0,
      discountrate: props.discountrate,
    });
  };

  const loeadtransaction = () => {
    if (props.code === "new") {
      setDisabled("");
      ClearFields();
      return;
    }
    setDisabled("disabled");

    if (props.returned === true) {
      setDisabled("");
    }

    Axios.get(serverURL + "/loadtransaction?code=" + props.code, bearer)
      .then((res) => {
        if (res.data !== "empty") {
          if (props.returned === true) {
            setDisabled("");
          } else {
            setDisabled("disabled");
          }
          setValues({
            ...frm,
            code: props.code,
            barcode: res.data.barcode,

            parentcode: props.parentcode,
            quantity: res.data.quantity,
            price: res.data.price,
            dateencoded: new Date(res.data.dateencoded),
            usercode: sessionStorage.getItem("msal.uc"),
            returned: res.data.returned,
            totalprice: res.data.totalprice,
            itemcode: res.data.itemcode,
            item: res.data.item,
            sellingprice: res.data.price,

            discountamount: res.data.discountamount,
            discountrate: res.data.discountrate,

            discount: res.data.discounttype,
            discountcode: res.data.discountcode,
          });
        } else {
          ClearFields();
        }
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const savesales = () => {
    const data = frm;

    Axios.post(props.apiServer + "/savesales", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          setValues({ ...frm, code: res.data.code });

          // notify(res.data.message);
          //  toast.info(res.data.message, {
          //     closeButton: false

          //   });
          //  props.showResult(res.data.message);
          props.refreshGrid(res.data.message);
          props.refreshSalesMain();
        } else {
          toast.warning(res.data.message, {
            closeButton: false,
          });

          setErrorMessage(res.data.message);
          toggleWarningBox();
          console.log(res.data.message);
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const [isAdmin, checkAdmin] = useState(0);

  function checkAdminAccess() {
    Axios.get(
      props.apiServer +
        "/getadminaccess?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  const [isPrintedAlready, setIfPrintedAlready] = useState(0);

  function checkIfPrintedAlready() {
    Axios.get(
      props.apiServer + "/getinvoicestatus?par=" + props.parentcode,
      bearer
    )
      .then((res) => {
        setIfPrintedAlready(0);
        setIfPrintedAlready(res.data[0].isprinted);
      })

      .catch((error) => {
        console.log(error);
      });
  }

  const toggleRequireAdmin = (transtype) => {
    showRequireAdmin(!modalRequireAdmin);
  };

  const [bolDeleted, setDeleted] = useState(false);
  const [bolAdmin, setAdminGranted] = useState(false);
  const [modalRequireAdmin, showRequireAdmin] = useState(false);

  const deleteRecord = () => {
    if (props.code === "new") {
      setErrorMessage("Please select a record!");
      toggleWarningBox();

      return;
    }
    console.log("delete " + props.code);
    confirmDeleteNoAdminAccess();
    // showRequireAdmin(!modalRequireAdmin);
  };

  function confirmDeleteNoAdminAccess() {
    removesales();
    // props.checkTotalSales();
    // props.refreshGrid("");

    // props.refreshGrid("");
    // showRequireAdmin(!modalRequireAdmin);
  }

  function confirmDelete() {
    removesales();
    // props.checkTotalSales();
    // props.refreshGrid("");

    // props.refreshGrid("");
    showRequireAdmin(!modalRequireAdmin);
  }

  const removesales = () => {
    const data = frm;

    Axios.post(props.apiServer + "/removesales", data, bearer)
      .then((res) => {
        // console.log(res.data.status);
        if (res.data.status === "1") {
          setDeleted(true);

          props.checkTotalSales();
          props.getdiscountinweek();
          props.refreshGrid(res.data.message);
        } else {
          setDeleted(false);

          setErrorMessage(res.data.message);
          //  toggleWarningBox();
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        setDeleted(false);
        //  toggleWarningBox();
      });

    //  props.refreshSalesMain();

    //  props.refreshGrid(res.data.message);
  };

  useMountEffect(checkAdminAccess);
  /* eslint-disable */

  useEffect(() => {
    loeadtransaction();
    checkIfPrintedAlready();
  }, [props.code]);

  // useEffect(() => {
  // console.log(bolDeleted);
  //  if(bolDeleted===true)
  //  {

  //  alert('deleted!');
  // props.checkTotalSales();

  //  }

  // }, [bolDeleted]);

  // useMountEffect(loadSeedPlanting);

  if (isPrintedAlready === 1) {
    return (
      <MDBRow>
        <MDBCol md="12">
          <h2 className="h1 display-5 font-weight-bold blue-text pb-4">
            <MDBIcon icon="lock" className="red-text"></MDBIcon>&nbsp;ACCESS
            DENIED
          </h2>

          <hr className="my-2" />

          <p>
            This sales invoice is already printed. Please use Returns module
            instead.
          </p>
        </MDBCol>
      </MDBRow>
    );
  }

  return (
    <React.Fragment>
      <MDBRow>
        <MDBCol md="12">
          <form
            className="needs-validation"
            onSubmit={submitHandler}
            noValidate
          >
            <MDBRow hidden>
              <MDBInput value={frm.code} id="code" label="Code">
                <div className="invalid-feedback">This field is required!</div>
                <div className="valid-feedback"></div>
              </MDBInput>
            </MDBRow>

            <MDBRow>
              <MDBCol md="12" className="text-left">
                {
                  <>
                    <h5 className="h4-responsive font-weight-bold">
                      <b>{frm.item}</b>
                    </h5>
                    <p>
                      <b>Barcode:</b> &nbsp; {frm.barcode}
                    </p>
                    <p>
                      <b>Qty:</b> &nbsp;{frm.quantity}{" "}
                    </p>
                    <p>
                      <b>Discount:</b> &nbsp;{frm.discount} ({frm.discountcode}){" "}
                    </p>
                    <p>
                      <b>Discount Rate:</b> &nbsp;{frm.discountrate}
                    </p>
                    <p>
                      <b>Selling Price: &nbsp;</b>
                      {frm.sellingprice}
                    </p>
                    <p>
                      <b>Discount Amount: &nbsp;</b>
                      {frm.discountamount}
                    </p>
                    <h4 className="red-text h4-responsive font-weight-bold">
                      TOTAL PRICE &nbsp;: &nbsp;
                      <span className="black-text">
                        P &nbsp; {frm.totalprice}
                      </span>
                    </h4>
                  </>
                }
              </MDBCol>
            </MDBRow>

            <MDBRow hidden>
              <MDBCol md="12" className="text-left">
                <MDBInput
                  autoFocus
                  value={frm.itemcode}
                  id="itemcode"
                  label="Item Code"
                  type="textarea"
                  onChange={updateField}
                  className={disabled}
                >
                  <div className="invalid-feedback">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>
                </MDBInput>
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <MDBCol md="10" className="text-left">
                {/* <MDBInput  
                                
                                value={frm.totalprice} 
                                id="totalprice"  
                                label="Total Price" 
                                type="number"
                                onChange={updateField}
                                className={disabled}
                                
                                >
                                    <div className="invalid-feedback">
                                    This field is required!
                                </div>
                                <div className="valid-feedback"></div>

                            </MDBInput> */}
              </MDBCol>
            </MDBRow>

            <MDBRow hidden>
              <MDBInput
                value={frm.parentcode}
                id="parentcode"
                label="parentcode"
              >
                <div className="invalid-feedback">This field is required!</div>
                <div className="valid-feedback"></div>
              </MDBInput>
            </MDBRow>

            <MDBBtn
              className="blue lighten-1"
              type="button"
              onClick={deleteRecord}
            >
              Delete
            </MDBBtn>
            {props.code === "new" ? (
              <MDBBtn
                className="cloudy-knoxville-gradient blue-text"
                onClick={props.toggleModal}
              >
                Close
              </MDBBtn>
            ) : (
              ""
            )}
          </form>
        </MDBCol>
      </MDBRow>

      <MDBModal
        backdrop={false}
        isOpen={modalRequireAdmin}
        toggle={deleteRecord}
      >
        <MDBModalHeader
          className="text-left black-text cloudy-knoxville-gradient"
          titleClass="w-100"
          tag="h5"
        ></MDBModalHeader>
        <MDBModalBody className="text-center">
          <AdminAccess
            deployURL={props.deployURL}
            apiServer={props.apiServer}
            apiServerHybrid={props.apiServerHybrid}
            toggleModal={toggleRequireAdmin}
            confirmDelete={confirmDelete}
            setAdminGranted={setAdminGranted}
          ></AdminAccess>

          {/* <MDBRow>
                        <MDBCol
                        size="3"
                        className="text-center"
                        >
                         <MDBIcon icon="trash-alt" size="5x" className="red-text" />  
                       
                        </MDBCol>
                        <MDBCol size="9" className="black-text text-center">
                        <p> 
                        
                        </p>
                        <p>
                           
                           Do you really want to delete this record?
                          
                        </p>
                        <p className="text-center">
                        <MDBBtn color="danger"  onClick={confirmDelete}>
                            Yes
                        </MDBBtn>
                        <MDBBtn className="cloudy-knoxville-gradient blue-text"  onClick={deleteRecord}>
                            Cancel
                        </MDBBtn>
                               
                        </p>
                        </MDBCol>
                  </MDBRow> */}
        </MDBModalBody>
      </MDBModal>

      <InfoBox
        errorMessage={errorMessage}
        isOpen={modalInfo}
        toggleModal={toggleInfoBox}
      />
      <WarningBox
        errorMessage={errorMessage}
        isOpen={modalWarning}
        toggleModal={toggleWarningBox}
      />
      {/* <MessagePersonalInfo /> */}
    </React.Fragment>
  );
};
export default ViewSales;
